import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { graphql } from 'gatsby';
import { OmRefinedInPageBanner } from '@om/component-library-react';
import { handleOmButtonClick } from './forms/OmButton';
import { getIsFormOpenAndPrepopulated} from '@om/redux/selectors/publicWeb/callMeBack';

const RefinedInPageBannerV2 = ({
    refinedInPageBannerContent,
    slot
}) => {
    const dispatch = useDispatch();
    let cmbData;

    if(refinedInPageBannerContent){
        cmbData = refinedInPageBannerContent.button;
    }
   
    const {
        isPrepopulatedCmb
    } = useSelector(
        createStructuredSelector({
            isPrepopulatedCmb: getIsFormOpenAndPrepopulated,

        })
    );

    useEffect(() => {
        if(isPrepopulatedCmb && cmbData)
            handleOmButtonClick(cmbData, dispatch, isPrepopulatedCmb, 'RefinedInPageBannerV2');
    }, [
        isPrepopulatedCmb, 
        cmbData
    ]);
  
    
    if (!refinedInPageBannerContent) {
        return '';
    }

    const {
        has_boundary,
        background,
        button,
        small_text,
        large_text,
    } = refinedInPageBannerContent;

    return (
        <OmRefinedInPageBanner
            slot={slot}
            hasBoundary={has_boundary}
            background={background && background.url}
            buttonActionObject={button && button.action && JSON.stringify(button.action[0])}
            buttonText={button && button.display_text}
            onButtonAction={(e) => {
                handleOmButtonClick(e, dispatch,isPrepopulatedCmb);
            }}
        >
            {
                small_text ? <span slot="small-text"
                    dangerouslySetInnerHTML={{__html: small_text}}/> : ''
            }
            {
                large_text ? <span slot="large-text"
                    dangerouslySetInnerHTML={{__html: large_text}}/> : ''
            }
        </OmRefinedInPageBanner>
    );
}


export const pageQuery = graphql`
fragment RefinedInPageBannerV2 on Contentstack_refined_in_page_banner_v2 {
    uid
    has_boundary
    background {
        ...File
    }
    button {
        ...RefinedInPageBannerButton
    }
    small_text
    large_text
}
`;

export default RefinedInPageBannerV2;
